<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  deliveries: { type: Array, default: () => [] },
});

const { t } = useI18n();

function formatDate(value) {
  return new Date(value).toLocaleString();
}
</script>

<template>
  <div class="flex flex-col gap-2">
    <h3 class="text-base font-medium text-n-slate-12">
      {{ $t('OTP_MESSAGES.DELIVERY_LOG') }}
    </h3>

    <p v-if="!deliveries.length" class="text-sm text-n-slate-11">
      {{ $t('OTP_MESSAGES.NO_DELIVERIES') }}
    </p>

    <table v-else class="w-full text-sm text-n-slate-12">
      <thead>
        <tr class="text-start text-n-slate-11 border-b border-n-weak">
          <th class="py-2 text-start font-medium">
            {{ $t('OTP_MESSAGES.PHONE_NUMBER') }}
          </th>
          <th class="py-2 text-start font-medium">
            {{ $t('OTP_MESSAGES.STATUS') }}
          </th>
          <th class="py-2 text-start font-medium">
            {{ $t('OTP_MESSAGES.ERROR') }}
          </th>
          <th class="py-2 text-start font-medium">
            {{ $t('OTP_MESSAGES.DATE') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="delivery in deliveries"
          :key="delivery.id"
          class="border-b border-n-weak"
        >
          <td class="py-2" dir="ltr">{{ delivery.phone_number }}</td>
          <td class="py-2">
            <span
              :class="{
                'text-n-teal-11': delivery.status === 'sent',
                'text-n-ruby-11': delivery.status === 'failed',
                'text-n-amber-11': delivery.status === 'pending',
              }"
            >
              {{ t(`OTP_MESSAGES.STATUS_${delivery.status.toUpperCase()}`) }}
            </span>
          </td>
          <td class="py-2 text-n-ruby-11">{{ delivery.error_message }}</td>
          <td class="py-2 text-n-slate-11">{{ formatDate(delivery.created_at) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
